import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImportContactsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"import_contacts"}/>
}
